import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 *
 * */
@Component({
  selector: 'campfire-news-details-modal',
  templateUrl: './news-details.modal.component.html',
  styleUrls: ['./news-details.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewsDetailsModalComponent {
  @Input() news: any;

  constructor(private modal: NgbActiveModal) {

  }

  get title(): string {
    return this.news.fields.Title;
  }

  get dateCreated(): Date {
    return new Date(this.news.createdDateTime);
  }

  get longFormDescription(): string {
    var string = this.news.fields.LongFormDescription;

    // If we see that the src parameter starts with `/sites/Campfire` we need to prefix the SP URL to this.

    var output =
      string
        .replace('src="/sites/Campfire/', 'src="https://navigatrgroup.sharepoint.com/sites/Campfire/')
        .replace(/&#58;/g, ':')
        .replace(/​/g, ''); // This is a special zero-width character, do not remove this.

    return output;
  }
}

